export const driversWidgetText = {
	panelHeader: 'Select a crew member to assign',
	errorMessage: "Can't fetch data, try again.",
	searchInfo: 'The search includes all crew members in the system.',
	perfectFit: 'Perfect Fit:',
	noCrewMembersFound: 'No crew members found',
	noEligibleCrewMembers: 'No eligible crew members found for this segment',
	warningTitle: 'Driver eligibility warning',
	warningDescription:
		'You are attempting to assign a driver who does not meet the required eligibility rules for this segment :',
	warningDisclaimer:
		'Proceeding with this action is at your own risk and may result in operational issues or non-compliance.',
	cancelButton: 'Cancel',
	assignAnyway: 'Assign anyway',
	delayTooSmall: 'The entered delay is too small.',
	delayTooLarge: 'The entered delay is too large.',
};
